import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { SportEventOffersV2FragmentDoc } from './SportEventOffersV2.fragment';
import { MultiStepSportEventParticipantsFragmentDoc } from './MultiStepSportEventParticipants.fragment';
export type MultiStepSportEventFragment = {
	__typename: 'MultiStepSportEvent';
	id: string;
	objectType: Types.ObjectType;
	objectId: number;
	sport: Types.SportType;
	content: {
		__typename?: 'MultiStepSportEventContent';
		status: Types.SportEventStatus;
		startAt: any;
		season?: { __typename?: 'SportSeason'; name: string } | null;
		competitionStage: {
			__typename?: 'SportCompetitionStageV2';
			name: Types.SportCompetitionStageName;
			number?: number | null;
		};
	};
	competition?: {
		__typename?: 'SportCompetitionV2';
		id: string;
		objectType: Types.ObjectType;
		objectId: number;
		sport: Types.SportType;
		activeSeason?: { __typename?: 'SportSeason'; name: string; seasonID: number } | null;
		content: { __typename?: 'SportCompetitionContentV2'; name: string; fullPath: string };
	} | null;
	mysportlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
	children: Array<{
		__typename?: 'MultiStepSportEvent';
		id: string;
		objectId: number;
		objectType: Types.ObjectType;
		offerCount: number;
		content: {
			__typename?: 'MultiStepSportEventContent';
			name: string;
			startAt: any;
			endAt?: any | null;
			status: Types.SportEventStatus;
			venue?: { __typename?: 'SportVenue'; venueID: number; name: string } | null;
			competitionStage: {
				__typename?: 'SportCompetitionStageV2';
				name: Types.SportCompetitionStageName;
				number?: number | null;
			};
		};
		watchNowOffer?: {
			__typename?: 'SportOffer';
			monetizationType: Types.MonetizationType;
			presentationType: Types.PresentationType;
			audioLanguage?: string | null;
			standardWebURL?: string | null;
			sportObjectType: Types.SportObjectType;
			package: {
				__typename?: 'Package';
				id: string;
				packageId: number;
				technicalName: string;
				clearName: string;
				shortName: string;
				monetizationTypes: Array<Types.MonetizationType>;
				iconWide: string;
			};
		} | null;
		offers: Array<{
			__typename?: 'SportOffer';
			monetizationType: Types.MonetizationType;
			presentationType: Types.PresentationType;
			audioLanguage?: string | null;
			standardWebURL?: string | null;
			sportObjectType: Types.SportObjectType;
			package: {
				__typename?: 'Package';
				id: string;
				packageId: number;
				technicalName: string;
				clearName: string;
				shortName: string;
				monetizationTypes: Array<Types.MonetizationType>;
			};
		}>;
	}>;
	parent?: {
		__typename?: 'MultiStepSportEvent';
		id: string;
		content: {
			__typename?: 'MultiStepSportEventContent';
			name: string;
			fullPath?: string | null;
			startAt: any;
			status: Types.SportEventStatus;
		};
	} | null;
};

export const MultiStepSportEventFragmentDoc = gql`
	fragment MultiStepSportEvent on MultiStepSportEvent {
		__typename
		id
		objectType
		objectId
		sport
		content(country: $country, language: $language) {
			season {
				name
			}
			status
		}
		competition {
			id
			objectType
			objectId
			sport
			activeSeason(country: $country, language: $language) {
				name
				seasonID
			}
			content(country: $country, language: $language) {
				name
				fullPath
			}
		}
		mysportlistEntry {
			createdAt
		}
		children {
			id
			objectId
			objectType
			content(country: $country, language: $language) {
				name
				startAt
				endAt
				status
				venue {
					venueID
					name
				}
				competitionStage {
					name
					number
				}
			}
			...SportEventOffersV2
		}
		...MultiStepSportEventParticipants
	}
	${SportEventOffersV2FragmentDoc}
	${MultiStepSportEventParticipantsFragmentDoc}
`;
